export default __webpack_public_path__ + "static/frame-bg-5782cdb39cd0fa819f4e50a1648da2ad.png";